import { useOutbox } from "./outbox";

export default function OutboxBanner() {
  const { count, online, authNeeded, flushNow } = useOutbox();
  if (online && count === 0) return null;
  const text = count === 0
    ? "Võrguühendus puudub — uued kirjed salvestatakse telefoni ja saadetakse hiljem."
    : authNeeded
      ? `${count} kirjet ootab saatmist — sessioon on aegunud, logi uuesti sisse.`
      : `${count} kirjet ootab saatmist${online ? "" : " (võrguühendus puudub)"} — proovin iga 30 s tagant uuesti.`;
  return (
    <div style={{
      background: authNeeded ? "#7f1d1d" : "#78350f", color: "#fff", fontSize: 12.5, fontWeight: 600,
      padding: "8px 14px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10,
    }}>
      <span>📶 {text}</span>
      {count > 0 && online && !authNeeded && (
        <button onClick={flushNow} style={{
          background: "rgba(255,255,255,0.18)", border: "1px solid rgba(255,255,255,0.4)", color: "#fff",
          borderRadius: 6, padding: "4px 10px", fontSize: 12, fontWeight: 700, cursor: "pointer", flexShrink: 0,
        }}>Saada kohe</button>
      )}
    </div>
  );
}
